<template>
  <authorization permissionKey="attendance_medical_record" can="read">
    <v-navigation-drawer
      color="white"
      width="221"
      :style="{ left: '82px', top: '24px' }"
      permanent
      clipped
      fixed
      class="pt-10 text-body-2 font-weight-bold"
    >
      <v-list class="mb-10" dense>
        <v-list-group>
          <template v-slot:activator>
            <v-list-item-content class="gray--text text--lighten-1">
              Facilitadores do Prontuário
            </v-list-item-content>
          </template>

          <authorization
            permissionKey="configuration_facilitator_hma"
            can="read"
          >
            <v-list-item link :to="`/configuracoes/hma`">
              <v-list-item-content class="gray--text text--lighten-1">
                H.M.A
              </v-list-item-content>
            </v-list-item>
          </authorization>         

          <authorization
            permissionKey="configuration_facilitator_hpp"
            can="read"
          >
            <v-list-item link :to="`/configuracoes/hpp`">
              <v-list-item-content class="gray--text text--lighten-1">
                H.P.P
              </v-list-item-content>
            </v-list-item>
          </authorization>

          <authorization
            permissionKey="configuration_facilitator_hf"
            can="read"
          >
            <v-list-item link :to="`/configuracoes/hf`">
              <v-list-item-content class="gray--text text--lighten-1">
                H.F
              </v-list-item-content>
            </v-list-item>
          </authorization>
          
          <authorization
            permissionKey="configuration_facilitator_bio"
            can="read"
          >
            <v-list-item link :to="`/configuracoes/bio`">
              <v-list-item-content class="gray--text text--lighten-1">
                Biomicroscopia
              </v-list-item-content>
            </v-list-item>
          </authorization>

          <authorization
            permissionKey="configuration_facilitator_fundoscopy"
            can="read"
          >
            <v-list-item link :to="`/configuracoes/fundoscopia`">
              <v-list-item-content class="gray--text text--lighten-1">
               Fundoscopia 
              </v-list-item-content>
            </v-list-item>
          </authorization>

        </v-list-group>

        <authorization
          permissionKey="configuration_facilitator_glasses_prescription"
          can="read"
        >
          <v-list-item link :to="`/configuracoes/receitas-oculos`">
            <v-list-item-content class="gray--text text--lighten-1">
              Receitas de óculos
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization
          permissionKey="configuration_facilitator_medication_history"
          can="read"
        >
          <v-list-item link :to="`/configuracoes/historia-medicamentosa`">
            <v-list-item-content class="gray--text text--lighten-1">
              História medicamentosa
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization
          permissionKey="configuration_facilitator_allergy"
          can="read"
        >
          <v-list-item link :to="`/configuracoes/alergias`">
            <v-list-item-content class="gray--text text--lighten-1">
              Alergias
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization
          permissionKey="configuration_facilitator_medicine"
          can="read"
        >
          <v-list-item link :to="`/configuracoes/medicamento`">
            <v-list-item-content class="gray--text text--lighten-1">
              Medicamentos
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization
          permissionKey="configuration_diagnostic_hypothesis"
          can="read"
        >
          <v-list-item link :to="`/configuracoes/hipotese-diagnostica`">
            <v-list-item-content class="gray--text text--lighten-1">
              Hipótese diagnóstica
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization
          permissionKey="configuration_facilitator_conduct"
          can="read"
        >
          <v-list-item link :to="`/configuracoes/conduta`">
            <v-list-item-content class="gray--text text--lighten-1">
              Conduta
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization permissionKey="configuration_prescription" can="read">
          <v-list-item link :to="`/configuracoes/receituario`">
            <v-list-item-content class="gray--text text--lighten-1">
              Receituário
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization permissionKey="configuration_template" can="read">
          <v-list-item link :to="`/configuracoes/protocolos`">
            <v-list-item-content class="gray--text text--lighten-1">
              Protocolos
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization permissionKey="configuration_service" can="read">
          <v-list-item link :to="`/configuracoes/servicos`">
            <v-list-item-content class="gray--text text--lighten-1">
              Serviços
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization permissionKey="configuration_appraisal" can="read">
          <v-list-item link :to="`/configuracoes/modelo-laudos`">
            <v-list-item-content class="gray--text text--lighten-1">
              Modelos de laudos
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization permissionKey="configuration_contact_len" can="read">
          <v-list-item link :to="`/configuracoes/lentes-contato`">
            <v-list-item-content class="gray--text text--lighten-1">
              Lentes de contato
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization permissionKey="configuration_surgery" can="read">
          <v-list-item link :to="`/configuracoes/cirurgia`">
            <v-list-item-content class="gray--text text--lighten-1">
              Cirurgia
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization permissionKey="configuration_prosthesis" can="read">
          <v-list-item link :to="`/configuracoes/proteses`">
            <v-list-item-content class="gray--text text--lighten-1">
              Próteses
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization permissionKey="configuration_user" can="read">
          <v-list-item link :to="`/configuracoes/usuarios`">
            <v-list-item-content class="gray--text text--lighten-1">
              Usuários
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization
          permissionKey="configuration_attendance_place"
          can="read"
        >
          <v-list-item link :to="`/configuracoes/ilhas-atendimento`">
            <v-list-item-content class="gray--text text--lighten-1">
              Ilhas de atendimento
            </v-list-item-content>
          </v-list-item>
        </authorization>

        <authorization
          permissionKey="configuration_medical_report_template"
          can="read"
        >
          <v-list-item link :to="`/configuracoes/relatorio-medico`">
            <v-list-item-content class="gray--text text--lighten-1">
              Relatório Médico
            </v-list-item-content>
          </v-list-item>
        </authorization>


        <authorization
          permissionKey="configuration_medical_report_template"
          can="read"
        >
          <v-list-item link :to="`/configuracoes/relatorios-exames`">
            <v-list-item-content class="gray--text text--lighten-1">
              Exames Executados
            </v-list-item-content>
          </v-list-item>
        </authorization>
      </v-list>
    </v-navigation-drawer>

    <v-main class="py-0" style="padding-left: 221px">
      <router-view />
    </v-main>
  </authorization>
</template>

<script>
export default {
  name: "Configs",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
